import { useState } from 'react';
import { Link } from 'react-router-dom';

export function PricingHero({ t }) {
  return (
    <section className="ssi-pricing__hero" style={pricingStyles.heroWrap}>
      <div style={pricingStyles.heroInner}>
        <div style={pricingStyles.heroKicker}>{t.pricingHeroKicker}</div>
        <h1 style={pricingStyles.heroH1}>{t.pricingHeroTitle}</h1>
        <p style={pricingStyles.heroLede}>{t.pricingHeroLede}</p>

        <div className="ssi-pricing__plans" style={pricingStyles.plans}>
          <div style={pricingStyles.planCard}>
            <div style={pricingStyles.planName}>{t.planMonthlyName}</div>
            <div style={pricingStyles.planPrice}>
              <span style={pricingStyles.planCurr}>£</span>
              <span style={pricingStyles.planNum}>{t.planMonthlyNum ?? '15'}</span>
              <span style={pricingStyles.planPer}>{t.planMonthlyPer ?? '/ month'}</span>
            </div>
            <p style={pricingStyles.planBlurb}>{t.planMonthlyBlurb}</p>
            <Link to="/pay?plan=monthly" style={pricingStyles.planCtaGhost}>
              {t.planMonthlyCta}
              <Arrow/>
            </Link>
            <ul style={pricingStyles.planList}>
              {[t.planLine1, t.planLine2, t.planLine3].map(l =>
                <li key={l} style={pricingStyles.planLi}><Tick/> <span>{l}</span></li>)}
            </ul>
          </div>

          <div style={{...pricingStyles.planCard, ...pricingStyles.planCardFeatured}}>
            <div style={pricingStyles.planBadge}>{t.planSaveBadge}</div>
            <div style={pricingStyles.planNameFeat}>{t.planAnnualName}</div>
            <div style={pricingStyles.planPriceFeat}>
              <span style={pricingStyles.planCurrFeat}>£</span>
              <span style={pricingStyles.planNumFeat}>{t.planAnnualNum ?? '150'}</span>
              <span style={pricingStyles.planPerFeat}>{t.planAnnualPer ?? '/ year'}</span>
            </div>
            <div style={pricingStyles.planStrike}>{t.planAnnualCompare}</div>
            <p style={pricingStyles.planBlurbFeat}>{t.planAnnualBlurb}</p>
            <Link to="/pay?plan=annual" style={pricingStyles.planCtaSolid}>
              {t.planAnnualCta}
              <Arrow light/>
            </Link>
            <ul style={pricingStyles.planListFeat}>
              {[t.planLine1, t.planLine2, t.planLine3, t.planAnnualExtra].map(l =>
                <li key={l} style={pricingStyles.planLiFeat}><Tick light/> <span>{l}</span></li>)}
            </ul>
          </div>
        </div>

        <div style={pricingStyles.trialStrip}>
          <strong style={{color:'var(--brandRed)'}}>{t.trialStripStrong}</strong> {t.trialStripRest}
        </div>
      </div>
    </section>
  );
}

function Arrow({ light }) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{marginLeft:8}}>
      <path d="M2 7h10m0 0L8 3m4 4L8 11" stroke={light ? '#fff' : 'currentColor'} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
function Tick({ light }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{flexShrink:0, marginTop:3}}>
      <path d="M3 8.5L6.5 12L13 4.5" stroke={light ? '#fff' : 'var(--brandRed)'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function PricingIncluded({ t }) {
  const langs = [
    { label: 'Welsh',     flag: 'wales.png' },
    { label: 'Spanish',   flag: 'spanish.svg' },
    { label: 'French',    flag: 'french.svg' },
    { label: 'Italian',   flag: 'italian.svg' },
    { label: 'German',    flag: 'german.svg' },
    { label: 'Portuguese',flag: 'portuguese.svg' },
    { label: 'Japanese',  flag: 'japanese.svg' },
    { label: 'Korean',    flag: 'korean.svg' },
    { label: 'Mandarin',  flag: 'chinese.svg' },
    { label: 'Arabic',    flag: 'arabic.svg' },
    { label: 'English',   initial: 'EN' },
  ];
  return (
    <section className="ssi-pricing__incl" style={pricingStyles.inclWrap}>
      <div style={pricingStyles.inclHead}>
        <div style={pricingStyles.kicker}>{t.inclKicker}</div>
        <h2 style={pricingStyles.h2}>{t.inclTitle}</h2>
        <p style={pricingStyles.inclLede}>{t.inclLede}</p>
      </div>
      <ul style={pricingStyles.langGrid}>
        {langs.map(l => (
          <li key={l.label} style={pricingStyles.langChip}>
            {l.flag
              ? <img src={`/assets/flag-${l.flag}`} alt="" style={pricingStyles.langFlag}/>
              : <span style={pricingStyles.langInitial}>{l.initial}</span>}
            <span style={pricingStyles.langLabel}>{l.label}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}

export function PricingPromise({ t }) {
  return (
    <section className="ssi-pricing__promise" style={pricingStyles.promiseWrap}>
      <div className="ssi-pricing__promiseCard" style={pricingStyles.promiseCard}>
        <div style={pricingStyles.promiseIcon} aria-hidden="true">
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
            <rect x="12" y="24" width="32" height="22" rx="4" stroke="#fff" strokeWidth="2"/>
            <path d="M18 24v-5a10 10 0 0120 0v5" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="28" cy="35" r="2" fill="#fff"/>
            <path d="M28 37v3" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <div>
          <div style={pricingStyles.kickerOnRed}>{t.promiseKicker}</div>
          <h2 style={pricingStyles.h2OnRed}>{t.promiseTitle}</h2>
          <p style={pricingStyles.pOnRed}>{t.promiseBody}</p>
        </div>
      </div>
    </section>
  );
}

export function PricingFAQ({ t }) {
  const qs = [
    { q: t.pfaqQ1, a: t.pfaqA1 },
    { q: t.pfaqQ2, a: t.pfaqA2 },
    { q: t.pfaqQ3, a: t.pfaqA3 },
    { q: t.pfaqQ4, a: t.pfaqA4 },
    { q: t.pfaqQ5, a: t.pfaqA5 },
  ];
  const [open, setOpen] = useState(0);
  return (
    <section className="ssi-pricing__faq" style={pricingStyles.faqWrap}>
      <div style={pricingStyles.faqHead}>
        <div style={pricingStyles.kicker}>{t.pfaqKicker}</div>
        <h2 style={pricingStyles.h2}>{t.pfaqTitle}</h2>
      </div>
      <ul style={pricingStyles.faqList}>
        {qs.map((qa, i) => {
          const isOpen = open === i;
          return (
            <li key={i} style={pricingStyles.faqItem}>
              <button
                type="button"
                onClick={() => setOpen(isOpen ? -1 : i)}
                style={pricingStyles.faqQ}>
                <span>{qa.q}</span>
                <span style={{...pricingStyles.faqChev, transform: isOpen ? 'rotate(180deg)' : 'none'}}>⌄</span>
              </button>
              {isOpen && <div style={pricingStyles.faqA}>{qa.a}</div>}
            </li>
          );
        })}
      </ul>
    </section>
  );
}

export function PricingGift({ t }) {
  return (
    <section className="ssi-pricing__gift" style={pricingStyles.giftWrap}>
      <div className="ssi-pricing__giftCard" style={pricingStyles.giftCard}>
        <div>
          <div style={pricingStyles.kicker}>{t.pgiftKicker}</div>
          <h3 style={pricingStyles.giftH3}>{t.pgiftTitle}</h3>
          <p style={pricingStyles.giftP}>{t.pgiftBody}</p>
        </div>
        <Link to="/gift" className="btn btn--primary" style={{alignSelf:'center', whiteSpace:'nowrap'}}>{t.pgiftCta}</Link>
      </div>
    </section>
  );
}

const pricingStyles = {
  kicker: { fontSize:12, letterSpacing:'.16em', textTransform:'uppercase', color:'var(--brandRed)', fontWeight:700, marginBottom:14 },
  kickerOnRed: { fontSize:12, letterSpacing:'.16em', textTransform:'uppercase', color:'#FFD8D4', fontWeight:700, marginBottom:14 },
  h2: { fontFamily:'var(--font-display)', fontWeight:700, fontSize:40, lineHeight:1.08, letterSpacing:'-.01em', margin:'0 0 16px', textWrap:'balance' },
  h2OnRed: { fontFamily:'var(--font-display)', fontWeight:700, fontSize:36, lineHeight:1.1, letterSpacing:'-.01em', margin:'0 0 14px', color:'#fff', textWrap:'balance' },
  pOnRed: { fontSize:17, lineHeight:1.6, color:'rgba(255,255,255,.92)', margin:0, maxWidth:'60ch' },

  heroWrap: { background:'var(--offWhite, #FDF5F5)', padding:'72px 32px 96px', borderBottom:'1px solid var(--border)' },
  heroInner: { maxWidth:1080, margin:'0 auto', textAlign:'center' },
  heroKicker: { fontSize:12, letterSpacing:'.16em', textTransform:'uppercase', color:'var(--brandRed)', fontWeight:700, marginBottom:18 },
  heroH1: { fontFamily:'var(--font-display)', fontWeight:700, fontSize:56, lineHeight:1.05, letterSpacing:'-.02em', margin:'0 auto 18px', textWrap:'balance', maxWidth:'18ch' },
  heroLede: { fontFamily:'var(--font-body)', fontSize:19, lineHeight:1.55, color:'var(--grey)', margin:'0 auto 48px', maxWidth:'58ch', textWrap:'pretty' },

  plans: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:20, textAlign:'left', maxWidth:860, margin:'0 auto' },
  planCard: { background:'#fff', borderRadius:20, padding:'36px 36px 32px', border:'1px solid var(--border)', position:'relative', display:'flex', flexDirection:'column' },
  planCardFeatured: { background:'var(--brandRed)', border:'1px solid var(--brandRed)', boxShadow:'0 24px 60px -20px rgba(73,3,0,.35)' },
  planBadge: { position:'absolute', top:-12, right:24, background:'var(--gold)', color:'#3a2900', padding:'6px 12px', borderRadius:999, fontSize:11, fontWeight:700, letterSpacing:'.12em', textTransform:'uppercase' },
  planName: { fontSize:13, letterSpacing:'.14em', textTransform:'uppercase', color:'var(--brandRed)', fontWeight:700, marginBottom:14 },
  planNameFeat: { fontSize:13, letterSpacing:'.14em', textTransform:'uppercase', color:'rgba(255,255,255,.8)', fontWeight:700, marginBottom:14 },
  planPrice: { display:'flex', alignItems:'baseline', gap:2, marginBottom:10 },
  planPriceFeat: { display:'flex', alignItems:'baseline', gap:2, marginBottom:6, color:'#fff' },
  planCurr: { fontFamily:'var(--font-display)', fontSize:28, color:'var(--fg-1)', fontWeight:500 },
  planCurrFeat: { fontFamily:'var(--font-display)', fontSize:28, color:'rgba(255,255,255,.9)', fontWeight:500 },
  planNum: { fontFamily:'var(--font-display)', fontSize:72, lineHeight:1, letterSpacing:'-.02em', fontWeight:500, color:'var(--fg-1)' },
  planNumFeat: { fontFamily:'var(--font-display)', fontSize:72, lineHeight:1, letterSpacing:'-.02em', fontWeight:500, color:'#fff' },
  planPer: { fontSize:15, color:'var(--grey)', marginLeft:4 },
  planPerFeat: { fontSize:15, color:'rgba(255,255,255,.78)', marginLeft:4 },
  planStrike: { fontSize:13, color:'rgba(255,255,255,.7)', marginBottom:14 },
  planBlurb: { fontSize:15, color:'var(--grey)', lineHeight:1.5, margin:'0 0 24px', minHeight:46 },
  planBlurbFeat: { fontSize:15, color:'rgba(255,255,255,.88)', lineHeight:1.5, margin:'0 0 24px', minHeight:46 },
  planCtaGhost: {
    display:'inline-flex', alignItems:'center', justifyContent:'center',
    padding:'14px 18px', borderRadius:12,
    border:'1px solid var(--border-strong)', background:'#fff',
    color:'var(--fg-1)', textDecoration:'none', fontSize:15, fontWeight:600,
  },
  planCtaSolid: {
    display:'inline-flex', alignItems:'center', justifyContent:'center',
    padding:'14px 18px', borderRadius:12,
    background:'#fff', color:'var(--brandRed)',
    textDecoration:'none', fontSize:15, fontWeight:600,
    boxShadow:'0 6px 16px -6px rgba(0,0,0,.35)',
  },
  planList: { listStyle:'none', padding:0, margin:'24px 0 0', display:'flex', flexDirection:'column', gap:10 },
  planListFeat: { listStyle:'none', padding:0, margin:'24px 0 0', display:'flex', flexDirection:'column', gap:10 },
  planLi: { display:'flex', gap:10, fontSize:14.5, color:'var(--fg-1)', lineHeight:1.45 },
  planLiFeat: { display:'flex', gap:10, fontSize:14.5, color:'#fff', lineHeight:1.45 },

  trialStrip: { maxWidth:720, margin:'40px auto 0', background:'#fff', border:'1px solid var(--border)', borderRadius:14, padding:'16px 24px', fontSize:14.5, color:'var(--grey)', lineHeight:1.5 },

  inclWrap: { padding:'120px 32px 80px', maxWidth:1240, margin:'0 auto' },
  inclHead: { textAlign:'center', maxWidth:720, margin:'0 auto 48px' },
  inclLede: { fontSize:18, lineHeight:1.55, color:'var(--grey)', margin:0, textWrap:'pretty' },
  langGrid: { listStyle:'none', padding:0, margin:'0 auto', maxWidth:1080, display:'flex', flexWrap:'wrap', justifyContent:'center', gap:12 },
  langChip: { display:'inline-flex', alignItems:'center', gap:10, padding:'10px 16px 10px 10px', background:'#fff', border:'1px solid var(--border)', borderRadius:999, boxShadow:'var(--shadow-sm)' },
  langFlag: { width:28, height:28, borderRadius:'50%', objectFit:'cover', display:'block' },
  langInitial: { width:28, height:28, borderRadius:'50%', display:'inline-flex', alignItems:'center', justifyContent:'center', fontSize:10, fontWeight:700, letterSpacing:'.05em', background:'var(--offWhite)', color:'var(--brandRed)' },
  langLabel: { fontSize:14, fontWeight:500, color:'var(--fg-1)' },

  promiseWrap: { padding:'0 32px 120px' },
  promiseCard: { maxWidth:1080, margin:'0 auto', background:'var(--brandRed)', color:'#fff', borderRadius:24, padding:'56px 56px', display:'grid', gridTemplateColumns:'80px 1fr', gap:32, alignItems:'center', boxShadow:'0 24px 60px -20px rgba(73,3,0,.45)' },
  promiseIcon: { width:80, height:80, borderRadius:20, background:'rgba(255,255,255,.12)', display:'flex', alignItems:'center', justifyContent:'center' },

  faqWrap: { background:'var(--offWhite, #FDF5F5)', padding:'120px 32px 120px' },
  faqHead: { maxWidth:760, margin:'0 auto 40px', textAlign:'center' },
  faqList: { listStyle:'none', padding:0, margin:'0 auto', maxWidth:760, background:'#fff', borderRadius:16, border:'1px solid var(--border)', overflow:'hidden' },
  faqItem: { borderBottom:'1px solid var(--border)' },
  faqQ: { width:'100%', textAlign:'left', background:'transparent', border:0, padding:'22px 24px', fontFamily:'inherit', fontSize:17, fontWeight:600, color:'var(--fg-1)', cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center', gap:16 },
  faqChev: { color:'var(--brandRed)', fontSize:18, transition:'transform 200ms' },
  faqA: { padding:'0 24px 24px', fontSize:15.5, color:'var(--grey)', lineHeight:1.6, maxWidth:'64ch', textWrap:'pretty' },

  giftWrap: { padding:'72px 32px 120px' },
  giftCard: { maxWidth:1080, margin:'0 auto', background:'#fff', border:'1px solid var(--border)', borderRadius:20, padding:'40px 48px', display:'grid', gridTemplateColumns:'1fr auto', gap:32, alignItems:'center', boxShadow:'var(--shadow-sm)' },
  giftH3: { fontFamily:'var(--font-display)', fontSize:28, margin:'0 0 10px', letterSpacing:'-.01em' },
  giftP: { fontSize:16, color:'var(--grey)', lineHeight:1.55, margin:0, maxWidth:'58ch' },
};
